<template>
  <el-dialog
    :visible.sync="visible"
    :title="$t('kyc.pending_popup_title')"
    width="980px"
    :close-on-click-modal="false"
    :show-close="true"
    class="pending-popup-dialog"
  >
    <!-- If KYC rejected (4) show rejected-only layout; if unverified (1) show original content -->
    <div v-if="kycStatus === 4">
      <div class="pending-tip">
        <svg-icon icon-class="warning" class-name="pending-tip-icon" />
        <div class="pending-tip-text">{{ $t('kyc.pending_rejected_tip') }}</div>
      </div>

      <div class="pending-table">
        <div class="pending-table-header">
          <div class="col col-business">{{ $t('kyc.pending_business_type') }}</div>
          <div class="col col-todo">{{ $t('kyc.pending_todo') }}</div>
          <div class="col col-op">{{ $t('kyc.pending_operation') }}</div>
        </div>

        <div class="pending-table-row">
          <div class="col col-business">
            <div class="business-label">{{ $t('kyc.pending_business_account_verification') }}</div>
          </div>
          <div class="col col-todo">
            <div class="todo-intro">{{ $t('kyc.pending_rejected_message') }}</div>
          </div>
          <div class="col col-op">
            <el-button type="primary" class="setup-now" @click="onSetupNow">{{ $t('kyc.pending_setup_now') }}</el-button>
          </div>
        </div>
      </div>
    </div>

    <div v-else-if="kycStatus === 1">
      <div class="pending-tip">
        <svg-icon icon-class="warning" class-name="pending-tip-icon" />
        <div class="pending-tip-text">{{ $t('kyc.pending_popup_tip') }}</div>
      </div>

      <div class="pending-table">
        <div class="pending-table-header">
          <div class="col col-business">{{ $t('kyc.pending_business_type') }}</div>
          <div class="col col-todo">{{ $t('kyc.pending_todo') }}</div>
          <div class="col col-op">{{ $t('kyc.pending_operation') }}</div>
        </div>

        <div class="pending-table-row">
          <div class="col col-business">
            <div class="business-label">{{ $t('kyc.pending_business_account_verification') }}</div>
          </div>
          <div class="col col-todo">
            <div class="todo-intro">{{ $t('kyc.pending_todo_intro') }}</div>
            <div class="todo-list">
              <div>i. {{ $t('kyc.pending_item_1') }}</div>
              <div>ii. {{ $t('kyc.pending_item_2') }}</div>
              <div>iii. {{ $t('kyc.pending_item_3') }}</div>
              <div>iv. {{ $t('kyc.pending_item_4') }}</div>
            </div>
          </div>
          <div class="col col-op">
            <el-button type="primary" class="setup-now" @click="onSetupNow">{{ $t('kyc.pending_setup_now') }}</el-button>
          </div>
        </div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: 'PendingPopup',
  data() {
    return {
      visible: false
    }
  },
  computed: {
    kycStatus() {
      const merchantInfo = this.$store.getters.userInfo && this.$store.getters.userInfo.merchant_info
      return merchantInfo && merchantInfo.kyc_status ? merchantInfo.kyc_status : null
    },
  },
  methods: {
    openDialog() {
      this.visible = true
    },
    onSetupNow() {
      this.visible = false
      this.$router.push('/kyc')
    },
    onClose() {
      this.visible = false
    }
  }
}
</script>

<style scoped>
.pending-table-header {
  background: #f7fafc;
  color: #1f2937;
  font-weight: 600;
}
.pending-tip {
  display: flex;
  align-items: center;
  background: #fff8e6;
  border-radius: 6px;
  padding: 12px 16px;
  margin-bottom: 16px;
  color: #c47b00;
}
.pending-tip-icon {
  width: 20px;
  height: 20px;
  margin-right: 12px;
}
.pending-table {
  border: 1px solid #eef2f7;
  border-radius: 6px;
  overflow: hidden;
  word-break: keep-all;
}
.pending-table-header {
  display: flex;
  background: #f7fafc;
  padding: 18px;
  font-weight: 600;
  color: #1f2937;
}
.pending-table-row {
  display: flex;
  padding: 24px;
  align-items: flex-start;
  gap: 16px;
  background: #ffffff;
}
.col { display: block; }
.col-business { width: 220px; padding-left: 8px; }
.col-todo { flex: 1; color: #13355a; line-height: 1.6; }
.col-op { width: 140px; display:flex; align-items:center; justify-content:center; }
.business-label { font-weight:700; color:#13355a; }
.todo-intro { margin-bottom:12px; }
.setup-now { border-radius:8px; padding:10px 18px; background:#2f5bff; color:#fff; border:none; }
.dialog-footer { border-top: none; }
.pending-badge-wrapper {
  position: relative;
  margin-bottom: 8px;
}
.pending-badge {
  display: inline-block;
  background: #f28b95;
  color: #fff;
  padding: 6px 10px;
  border-radius: 4px;
  font-weight: 600;
}
.setup-now-link {
  color: #2f5bff;
  padding: 0;
}
</style>

